/* Copyright (C) 2020 Soil Capital Belgium SPRL - All Rights Reserved */
function getErrors(errors, name) {
  const filter = errors.filter((error) => error.field === name);
  const currentError = filter.length > 0 ? filter[0] : null;

  return currentError ? currentError.message : "";
}

export default getErrors;
